<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Department</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="flex-full">
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="name" id="name" required />
        @if (form.get('name')?.hasError('required')) {
          <mat-error> Name is required. </mat-error>
        }
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error> Name limited to 50 characters. </mat-error>
        }
        @if (form.get('name')?.hasError('noContent')) {
          <mat-error> Name must contain characters. </mat-error>
        }
        @if (form.get('name')?.hasError('pattern')) {
          <mat-error>
            Invalid Name. Name may include letters, numbers, and characters. No leading/trailing spaces.
          </mat-error>
        }
        @if (form.hasError('uniqueName', 'name')) {
          <mat-error
            >This name is already used by an active or inactive department.
          </mat-error>
        }
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button type="submit" title="Create" mat-raised-button>Save</button>
    </mat-dialog-actions>
  </form>
</lcs-loading-overlay>
